import { render, staticRenderFns } from "./UpperDashboard.vue?vue&type=template&id=4a2b1459&"
import script from "./UpperDashboard.vue?vue&type=script&lang=js&"
export * from "./UpperDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UpperDashboard.vue?vue&type=style&index=0&id=4a2b1459&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports